
// defauld Grid Settings
export const defaultBreakPoints = {
    "xs": 12,
    "md": 3,
}

export const defaultContainerSpacing = {
    "spacing": 16,
    "alignContent": 'flex-start'
}
export const accountGridSettings = {
    "breakPoints": defaultBreakPoints,
    "container": defaultContainerSpacing
}

// HOME PAGE GRID SETTINGS

const minGridBreakPoints = {
    "xs": 'auto',
    "md": 'auto'
}
const minGridContainerSpacing = {
    "spacing": 8,
}

export const homeGridSettings = {
    "breakPoints": minGridBreakPoints,
    "container": minGridContainerSpacing
}

const rowBreakPoints = {
    "xs": "auto",
    "md": 12,
    "direction": "row",
    "alignItems":"flex-start",
    "alignContent": 'flex-start'
}
export const eventListGridSettings = {
    "breakPoints": rowBreakPoints,
    "container": minGridContainerSpacing,
    "nestedBreakPoints": minGridBreakPoints
}

export const defaultGridSettings = {
    "container": {
        "spacing": 8,
    },
    "item": {
        "xs": 12,
        "sm": 6,
        "md": 3,


    }
}


// WEBPACK FOOTER //
// ./src/js/settings/grid.js